import React from "react";
import { useNavigate } from "react-router-dom";
import "./Success.css";
import { Helmet } from "react-helmet-async";

function Success() {
  const navigate = useNavigate();

  const lastOrder =
    JSON.parse(localStorage.getItem("lastOrder")) || {};

  return (
    <>
     <Helmet>
            <title>success</title>
            <link rel="canonical" href="https://realgenericshop.com/success" />
            <meta name="description" content="Order Placed Successfully" />
            

     </Helmet>
    <div className="success-page">
      <div className="success-box">

        <div className="success-icon">
          ✓
        </div>

        <h1>
          Order Placed Successfully
        </h1>

        <p>
          Thank you for your order.
          <br />
          Your order has been received and is being processed.
        </p>

        {lastOrder.invoiceNumber && (
          <div className="order-reference">
            <strong>
              Order Reference: {lastOrder.invoiceNumber}
            </strong>
          </div>
        )}

        <div className="success-buttons">

          <button
            onClick={() => navigate("/")}
          >
            Continue Shopping
          </button>

          <button
            onClick={() => navigate("/my-orders")}
          >
            My Orders
          </button>

          {lastOrder.invoiceNumber && (
            <button
              onClick={() => navigate("/checkout/invoice")}
            >
              Download Invoice
            </button>
          )}

        </div>

      </div>
    </div>
    </>
  );
}

export default Success;